import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=670bacc4&"
import script from "./UserProfile.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserProfile.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=670bacc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports